import React, { PropsWithChildren, ReactNode, useState } from "react";

import { Button, IconButton } from "@material-ui/core";
import ReplayIcon from "@material-ui/icons/Replay";

import { DialogWithActions } from "../";
import { User } from "../../../graphql/models";
import { useSnackbarMessage, useSnackbarMutation } from "../../../hooks";
import { MUTATIONS } from "../../../graphql";

export interface ResetUserActivationButtonWithDialogProps
  extends PropsWithChildren<any> {
  filterDialogTitle?: string;
  filterDialogActions?: ReactNode[];
  user: User;
  onClosed?: () => void;
}

function ResetUserActivationButtonWithDialog(
  props: ResetUserActivationButtonWithDialogProps
) {
  const {
    filterDialogTitle,
    filterDialogActions = [],
    onClosed,
    user,
    children,
  } = props;

  const { raiseSuccessSnackbar } = useSnackbarMessage();
  const [filterDialogOpened, setFilterDialogOpened] = useState(false);
  const [invokeResetActivationProcess, { loading }] = useSnackbarMutation(
    MUTATIONS.RESET_ACTIVATION_PROCESS,
    {
      onCompleted: ({ resetActivationProcess }) => {
        if (resetActivationProcess?.ok) {
          onClosed && onClosed();
          setFilterDialogOpened(false);
          raiseSuccessSnackbar("Processo resettato con successo!");
        }
      },
    }
  );

  const onFilterIconClick = () => setFilterDialogOpened(true);
  const onUndoClick = () => {
    onClosed && onClosed();
    setFilterDialogOpened(false);
  };

  const onConfirmClick = () => {
    invokeResetActivationProcess({
      variables: {
        userId: user.id,
      },
    });
  };

  return (
    <>
      <IconButton color="secondary" onClick={onFilterIconClick}>
        <ReplayIcon />
      </IconButton>
      <DialogWithActions
        fullScreen={false}
        fullWidth={true}
        open={filterDialogOpened}
        setOpen={setFilterDialogOpened}
        actions={[
          ...filterDialogActions,
          <Button
            key="onUndoClick"
            disabled={loading}
            onClick={onUndoClick}
            variant="outlined"
            color="secondary"
          >
            Annulla
          </Button>,
          <Button
            key="onConfirmClick"
            disabled={loading}
            onClick={onConfirmClick}
            variant="outlined"
            color="primary"
          >
            Conferma ed effettua il reset
          </Button>,
        ]}
        title={filterDialogTitle ?? "Reset processo di attivazione utente"}
      >
        Il processo di reset di attivazione consente di ripristinare il flusso
        in modo tale che l'utente possa nuovamente completare il processo di
        verifica ed effettuare il suo primo accesso all'app. <br />
        Ricorda che non è possibile effettuare il reset del processo di
        attivazione di un utente che è già attivo: in questo caso l'utente può
        recuperare in autonomia le credenziali tramite le funzioni offerte
        dall'applicazione.
        <br />
        <br />
        {children}
        Confermi di voler procedere con il reset del processo di attivazione per
        l'utente <i>{user.username}</i>?
      </DialogWithActions>
    </>
  );
}

export { ResetUserActivationButtonWithDialog };
